import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'

import LocationForm from './LocationForm'
import DoctorForm from './DoctorForm'
import css from './ManualSync.css'

export default class ManualSync extends Component {
  static propTypes = {
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
    createOrUpdateDoctor: PropTypes.func.isRequired,
    createOrUpdateLocation: PropTypes.func.isRequired,
    website: PropTypes.string,
  }

  static defaultProps = {
    website: null,
  }

  state = {
    isLocationFormOpen: this.props.locations.length === 0,
    isDoctorFormOpen: this.props.doctors.length === 0,
    editingLocation: null,
    editingDoctor: null,
  }

  renderLocation = location => (
    <li key={location.id} className={css.item}>
      <p>
        <Button
          className={css.smallButton}
          icon="edit"
          size="small"
          onClick={() => this.editLocation(location)}
        />
        <span>{location.name}</span>
      </p>
      <span>{location.street_address}</span>
      <span>{location.secondary_address}</span>
      <span>{location.city}, {location.state} {location.zip}</span>
      <span>{location.website}</span>
    </li>
  )

  renderDoctor = doctor => (
    <li key={doctor.id} className={css.item}>
      <p>
        <Button
          className={css.smallButton}
          icon="edit"
          size="small"
          onClick={() => this.editDoctor(doctor)}
        />
        <span>{doctor.title} {doctor.first_name} {doctor.last_name}</span>
      </p>
      <span>Preferred name: {doctor.preferred_name}</span>
      <span>Email: {doctor.email}</span>
    </li>
  )

  toggleDoctorForm = () => {
    this.setState(prevState => ({
      isDoctorFormOpen: !prevState.isDoctorFormOpen,
      editingDoctor: null,
    }))
  }

  toggleLocationForm = () => {
    this.setState(prevState => ({
      isLocationFormOpen: !prevState.isLocationFormOpen,
      editingLocation: null,
    }))
  }

  editDoctor = (doctor) => {
    this.setState({
      editingDoctor: doctor,
      isDoctorFormOpen: true,
    })
  }

  editLocation = (location) => {
    this.setState({
      editingLocation: location,
      isLocationFormOpen: true,
    })
  }

  render() {
    const { locations, doctors, createOrUpdateDoctor, createOrUpdateLocation, website } = this.props

    const locationElems = locations.map(loc => this.renderLocation(loc))
    const doctorElems = doctors.map(doc => this.renderDoctor(doc))
    return (
      <div className={css.container}>
        <div className={css.section}>
          <ul className={css.list}>
            {locationElems}
            { this.state.isLocationFormOpen
            ? <LocationForm
              addOrEdit={createOrUpdateLocation}
              hideForm={this.toggleLocationForm}
              location={this.state.editingLocation}
              websiteFromProps={website}
            />
            :
            <Button
              onClick={this.toggleLocationForm}
              className={css.addButton}
              icon="plus"
            >
              Add Location
            </Button>
          }
          </ul>
        </div>
        <div className={css.section}>
          <ul className={css.list}>
            {doctorElems}
            { this.state.isDoctorFormOpen
            ? <DoctorForm
              addOrEdit={createOrUpdateDoctor}
              hideForm={this.toggleDoctorForm}
              doctor={this.state.editingDoctor}
            />
            :
            <Button
              onClick={this.toggleDoctorForm}
              className={css.addButton}
              icon="plus"
            >
              Add Doctor
            </Button>
          }
          </ul>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/AddPractice/Info/ManualSync.js